import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {number} from 'yargs'

export enum RechargeEnum {
  主播钱包 = 0,
  普通充值 = 1,
  币商充值 = 2,
}

export interface RedirectInfo {
  redirect_url: string
  redirect_param: {[key: string]: string}
  redirect_method: 'get' | 'post'
}

export interface ProductsItemInterface {
  coins?: number
  desc?: string
  dt?: number
  id?: string
  name?: string
  out_code?: string
  price?: number
  type?: string
  currency?: string
  chat_tag?: string
}
export interface ThirdPartyListItem {
  pay_method_id: number
  name: string
  img: string
  is_unfold: boolean
  list: Array<{
    product_id: string
    price: number
    coins: number
    currency: string
  }>
}

export interface ProductsListInterface {
  client_index: number // 客户端商品下标 需要进行优化，client_index为客户端充值渠道在第三方充值中的位置
  huawei_list: ProductsItemInterface[]
  list: ProductsItemInterface[]
  visa_list: ProductsItemInterface[]
  coins: number
  agreement_url: string
  tickets: number
  status: number
  exchange_cnt: number
  remain_tm: number
  is_recharged: number
  is_aristocracy: number
  before_recharged: number
  is_ra_customer: boolean
  exchange_tickets_ratio: number
  countries: Array<{
    code: number
    name: string
  }>
  default_country: {
    code: number
    name: string
  }
  third_party_list?: ThirdPartyListItem[]
  is_union: number // 是否是公会主播
  recharge_version: 'v1' | 'v2' // 控制新版首充礼包AB文案
  is_first_recharge: boolean
  baseInfo?: {
    mid: number //	用户mid
    show_id: string //	用户展示ID
    avatar_url: string //	头像URL
    name: string // 用户昵称
    region_code: number
  }
  extra_desc_url: string // chat业务充值额外奖励说明页地址
  is_audit_ver?: boolean // 由服务端下发，不写入 initialState
}

export enum LimitEnum {
  固定值 = 1,
  直播比例 = 2,
  直播流转比例 = 3,
}

export interface ProductItem {
  product_id: string
  price: number
  coins: number
  currency: string
}
const initialState: any = {}
const initData: {
  wallet: Partial<ProductsListInterface>
  chips: {
    chip_balance: number
    list: Array<{id: number; chips_amount: number; coins_price: number}>
  }
  wallet_product: {
    balance_info?: {
      // 钱包信息
      total: number // 总余额
      overage: number // 可提现余额
      frozen_overage: number // 冻结余额
      auditing_overage: number // 审核中余额（包含冻结的）
      is_new: boolean // 是否有新入账
    }
    max_cash_out_info?: {
      // 最大可提取信息
      no_show_channles: Array<number> // 不展示的渠道 如果是-1，则全部不展示 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448874
      limit_kind: LimitEnum // 限制类型 1固定值 2全公会直播总收入*比例 3全公会(直播+流转)总收入*比例
      percent: number // 百分比
      cfg_max_amount: number // 最大薪资数
      could_amount: number // 可以提取的的最大薪资数
    }
    coins_product?: {
      // 普通金币产品
      pay_method_id: number // 支付方式ID
      name: string // 显示名称
      img: string // 显示icon
      is_unfold: boolean // 是否展开
      list: Array<ProductItem> // 商品列表
      is_show: boolean // true:展示； 是否展示该产品 用户满足金刚区内的可见薪资钱包入口的身份； 用户的转金币table开关打开；
      is_in_window: boolean // true:在窗口；当用户当前没有在「薪资转金币」窗口中时，展示可提现余额，但是不展示SKU，提示用户不在窗口期，无法转金币
    }
    ra_coins_product?: {
      // 币商金币产品
      pay_method_id: number // 支付方式ID
      name: string // 显示名称
      img: string // 显示icon
      is_unfold: boolean // 是否展开
      list: Array<ProductItem> // 商品列表
      is_show: boolean // true:展示； 是否展示该产品 用户满足金刚区内的可见薪资钱包入口的身份； 用户的转金币table开关打开；
      is_in_window: boolean // true:在窗口；当用户当前没有在「薪资转金币」窗口中时，展示可提现余额，但是不展示SKU，提示用户不在窗口期，无法转金币
    }
  }
  recharge: {
    first_charge_page_icon?: string
  }
} = {
  wallet: {
    client_index: 0,
    huawei_list: [],
    list: [],
    visa_list: [],
    coins: 0,
    agreement_url: '',
    tickets: 0,
    status: 0,
    exchange_cnt: 0,
    remain_tm: 0,
    is_recharged: 0,
    is_aristocracy: 0,
    before_recharged: 0,
    is_ra_customer: false,
    exchange_tickets_ratio: 0,
    countries: [],
    default_country: {
      code: 0,
      name: '',
    },
    is_union: 0, // 是否是公会主播
    recharge_version: 'v1', // 控制新版首充礼包AB文案
    is_first_recharge: false,
    extra_desc_url: '',
  },
  chips: {
    chip_balance: 0,
    list: [],
  },
  wallet_product: {},
  recharge: {}, // 首充信息
}

export const getMyRechargeGroup = createAsyncThunk(
  'hiyaWallet2/getMyRechargeGroup',
  async (params, store: any) => {
    const resp = await http.post('/live/activity/sb_enter_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const createRechargeOrderV2 = createAsyncThunk(
  'hiyaWallet2/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
        ...params,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const exchangeTickets = createAsyncThunk(
  'hiyaWallet2/exchangeTickets',
  async (param: {tickets: number}, store: any) => {
    const resp = await http.post('/live/user/exchange_tickets', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
      ...param,
    })
    return resp.data
  }
)

export const exchangeChips = createAsyncThunk(
  'hiyaWallet2/exchangeChips',
  async (
    {product_id, from}: {product_id: number; from?: string},
    store: any
  ) => {
    const resp = await http.post('/gamestore/common/account_exchange_in', {
      ...store.getState().env.deviceinfo,
      product_id,
      from,
    })
    return resp.data
  }
)

export const getChipsInfo = createAsyncThunk(
  'hiyaWallet2/getChipsInfo',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/gamestore/common/account_info',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const getChipsProductList = createAsyncThunk(
  'hiyaWallet2/getChipsProductList',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/gamestore/common/chips_products',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const getProductsList = createAsyncThunk(
  'hiyaWallet2/getProductsList',
  async (param: any = {}, store: any) => {
    const resp = await http.post('/live/pay/get_products_list', {
      ...store.getState().env.deviceinfo,
      ...param,
      before_recharged: 1,
    })
    return resp.data
  }
)

export const getRechargeBonus = createAsyncThunk(
  'hiyaWallet2/getRechargeBonus',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/recharge_bonus', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data
  }
)
// [web通过mid获取用户信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438988
export const simpleMemberByMid = createAsyncThunk(
  'hiyaWallet2/simpleMemberByMid',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data.data
  }
)

// 充值入口 薪资转金币 http://wiki.xunlei.cn/pages/viewpage.action?pageId=145475403
// use 充值wallet 币商充值
// from :RechargeFrom
// RechargeFromWallet         RechargeFrom = 0 // 主播钱包
// RechargeFromCommonRecharge RechargeFrom = 1 // 通用普通充值页面
// RechargeFromRaRecharge     RechargeFrom = 2 // 通用币商充值页面
export const walletProductList = createAsyncThunk(
  'hiyaWallet2/get_wallet_product_list',
  async (any: any, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/account/get_wallet_product_list', {
      ...any,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 获取首充的banner
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=155164327
export const get_recharge_count_down = createAsyncThunk(
  '/live/activity/get_recharge_count_down',
  async (any: any, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/live/activity/get_recharge_count_down',
      {
        ...any,
        ...store.getState().env.deviceinfo,
      },
      {store}
    )
    return resp.data.data
  }
)

export const HiyaWalletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      // 防止已经保存的数据被完全清除
      Object.assign(state.wallet, {...data})
    })
    builder.addCase(getChipsProductList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {chips} = state
      Object.assign(state, {chips: {...chips, ...data}})
    })
    builder.addCase(getChipsInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {chips} = state
      Object.assign(state, {chips: {...chips, ...data}})
    })
    builder.addCase(simpleMemberByMid.fulfilled, (state, action) => {
      Object.assign(state.wallet, {
        baseInfo: action.payload,
      })
    })
    builder.addCase(walletProductList.fulfilled, (state, action) => {
      Object.assign(state.wallet_product, {
        ...action.payload,
      })
    })
    builder.addCase(get_recharge_count_down.fulfilled, (state, action) => {
      Object.assign(state.recharge, {
        ...action.payload,
      })
    })
  },
})
export default HiyaWalletSlice.reducer
export const HiyaWalletActions = HiyaWalletSlice.actions
